import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { onPageEditing } from 'utils';

import css from './LinkGroupListBlock.module.scss';

const LinkGroupListBlock = ({
    blockId,
    heading,
    backgroundImage,
    linkGroups
}) => (
    <div
        className={cn(css.block, {
            [css.background]: backgroundImage
        })}
        data-block={blockId}
    >
        {heading && (
            <div className={css.heading} {...onPageEditing('Heading')}>
                <h3 className="block-title-large">{heading}</h3>
            </div>
        )}
        {linkGroups.length > 0 && (
            <div className={css.wrapper} {...onPageEditing('LinkGroups')}>
                {linkGroups.map((g,i) => (
                    <nav className={css.group} key={i}>
                        {g.headingAsLink
                            ? <a href={g.headingAsLink}>{g.heading}</a>
                            : g.heading && <p>{g.heading}</p>
                        }
                        <ul className={css.links}>
                            {g.linkCollection !== null && g.linkCollection.map(l => (
                                <li key={l.text}>
                                    <a
                                        href={l.href}
                                        target={l.target}
                                    >{l.text}</a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                ))}
            </div>
        )}
    </div>
);

LinkGroupListBlock.propTypes = {
    blockId: PropTypes.number.isRequired,
    heading: PropTypes.string,
    backgroundImage: PropTypes.bool,
    linkGroups: PropTypes.arrayOf(PropTypes.shape({
        heading: PropTypes.string,
        headingAsLink: PropTypes.string,
        linkCollection: PropTypes.any,
    })).isRequired,
};

export default LinkGroupListBlock;



// WEBPACK FOOTER //
// ./src/components/LinkGroupListBlock/LinkGroupListBlock.jsx